export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_825f430eca78f311233920ce